import {
  ComponentFactoryResolver,
  type ComponentRef,
  Directive,
  inject,
  input,
  type OnChanges,
  type OnDestroy,
  type SimpleChanges,
  ViewContainerRef,
} from "@angular/core";
import type { Corpus } from "@pienso/ingest-types/corpus.interface";
import { Page } from "./grid-data.provider";
import type { HeaderRendererColumn } from "./header-renderer.interface";
import type { HeaderRendererItem } from "./header-renderer-item";

@Directive({ selector: "[pHeaderRenderer]" })
export class HeaderRendererDirective implements OnChanges, OnDestroy {
  viewContainerRef = inject(ViewContainerRef);
  private componentFactoryResolver = inject(ComponentFactoryResolver);

  readonly pHeaderRenderer = input.required<HeaderRendererItem>();
  readonly corpus = input.required<Corpus>();
  readonly column = input.required<HeaderRendererColumn>();
  readonly editable = input.required<boolean>();
  readonly page = input<Page>(new Page());

  private componentRef: ComponentRef<unknown> | undefined;

  ngOnChanges(changes: SimpleChanges) {
    if (changes["pHeaderRenderer"]) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.pHeaderRenderer().component);
      this.viewContainerRef.clear();
      this.componentRef = this.viewContainerRef.createComponent(componentFactory);
    }
    this.updateContents();
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  private updateContents() {
    if (this.componentRef) {
      this.componentRef.setInput("corpus", this.corpus());
      this.componentRef.setInput("column", this.column());
      this.componentRef.setInput("editable", this.editable());
      this.componentRef.setInput("page", this.page());
    }
  }
}

/*
Format of column:

column: {
  canAutoResize: boolean
  cellTemplate: TemplateRef
  draggable: boolean
  headerTemplate: TemplateRef
  name: string -- e.g. "Some Name"
  prop: string -- e.g. "col0"
  resizeable: boolean
  sortable: boolean
  width: number,
  dataType: { type: ES_TYPE, format?: string }
}

 */
